export const PUBLIC_API = {
  webhooks: {
    base: '/webhooks',
    event: '/event/:org',
    eventSource: '/event/:org/:source',
    formEventSource: '/form-event/:org/:source',
    form: '/form',
    riskRating: '/risk-rating',
    leads: '/leads/sync',
    efax: '/efax',
    stripe: '/stripe',
    dosespot: '/dosespot',
    appointments: '/appointment',
    bigcommerce: '/bigcommerce',
    sendgrid: '/sendgrid'
  },
  appointments: {
    base: '/appointments',
    findStartUrl: '/findStartUrl',
    single: '/:id',
    cancel: '/cancel/:id',
    cancelByOtp: '/cancel/otp'
  },
  form: {
    base: '/form'
  },
  leads: {
    base: '/leads',
    checkEmail: '/check/email',
    checkPhone: '/check/phone',
    requestOtpByEmail: '/otp/email',
    requestOtpByPhone: '/otp/phone',
    requestMagicLink: '/link',
    authOtp: '/auth/otp',
    authOtpPaymentMethods: '/auth/otp/payment-methods',
    authMagicLink: '/auth/link'
  },
  services: {
    base: '/services',
    single: '/:id',
    singleServiceAvailability: '/:id/availability',
    singleServiceAvailabilityV2: '/:id/availability-v2',
    consentSection: '/consent'
  },
  carts: {
    base: '/carts',
    checkout_url: '/checkout-url',
    single: '/:id',
    itemsBase: '/:id/items',
    related: '/:id/related',
    updateItems: '/:id/items/:itemId',
    theme: '/theme',
    updateExtras: '/:id/extras'
  },
  products: {
    base: '/products',
    single: '/:id',
    categories: '/categories'
  }
};
